export default __webpack_public_path__ + "static/media/icn-close.6844a588.svg";